import { useUsersQuery, useCreateUserMutation, useUpdateUserMutation, useDeleteUserMutation } from './useUsersQuery';
import { User } from '../types';
import moment from 'moment';

export const useUser = (userId?: string) => {
    // Users are fetched from the list and looked up by id (sub)
    // The API uses username for individual operations
    const { data: users = [], isLoading: loading } = useUsersQuery();
    const record = userId ? users.find(u => u.id === userId || u.sub === userId) : undefined;

    const createUserMutation = useCreateUserMutation();
    const updateUserMutation = useUpdateUserMutation();
    const deleteUserMutation = useDeleteUserMutation();

    const fetchRecord = () => {
        // No-op: React Query handles fetching automatically
    };

    const createRecord = async (values: User) => {
        const {
            id: _id,
            sub: _sub,
            emailVerified: _emailVerified,
            phoneNumberVerified: _phoneNumberVerified,
            ...rest
        } = values;
        return await createUserMutation.mutateAsync(rest);
    };

    const updateRecord = async (values: User) => {
        if (!record?.username) {
            throw new Error('username is required for update');
        }

        const birthDate = moment(values.birthDate).format('YYYY-MM-DD');

        const {
            id: _id,
            sub: _sub,
            emailVerified: _emailVerified,
            phoneNumberVerified: _phoneNumberVerified,
            ...rest
        } = values;

        return await updateUserMutation.mutateAsync({
            username: record.username,
            record: { ...rest, birthDate } as User,
        });
    };

    const deleteRecord = async () => {
        if (!record?.username) {
            throw new Error('username is required for delete');
        }
        return await deleteUserMutation.mutateAsync(record.username);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
